import { createClient } from '@supabase/supabase-js';
import env from '@shared/api/env';
import type { Database } from '../database.types';

// Workspace-aware header injection for all Supabase REST requests
let currentWorkspaceId: string | null = null;
export function setSupabaseWorkspace(workspaceId: string | null) {
  currentWorkspaceId = workspaceId ?? null;
}

// Base URL must be the origin hosting /auth/v1 and /rest/v1
// For local docker: http://localhost (SDK appends the /auth/v1 & /rest/v1 paths)
export const supabase = createClient<Database>(env.SUPABASE_URL, env.SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'bunker.auth',
  },
  global: {
    // Inject X-Workspace-ID on every request if available
    fetch: async (input: RequestInfo | URL, init?: RequestInit) => {
      const headers = new Headers(init?.headers ?? {});
      if (currentWorkspaceId) headers.set('X-Workspace-ID', currentWorkspaceId);
      return fetch(input, { ...init, headers });
    },
  },
});

export default supabase;
